const circleSecondaryButtonStyles = theme => ({
  '.btn-circle-secondary': {
    color: theme('colors.green1.55'),
    // Use box-shadow instead of border to avoid affecting overall size
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,
    'a&:hover, a&:focus': {
      color: theme('colors.green1.60'),
    },
    '&:hover, &:focus': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.60')}`,
    },
    '&:active:enabled': {
      backgroundColor: theme('colors.green1.65'),
      boxShadow: 'none',
      color: theme('colors.white'),
    },
    '&.disabled': {
      color: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.30')}`,
    },
  },

  '.btn-circle-secondary-filled': {
    backgroundColor: theme('colors.white'),
  },
});

module.exports = { circleSecondaryButtonStyles };
